import { Stack, Typography } from "@mui/material";
import type { ContextGroup } from "Components/Users/ConnectedBankAccounts/useGroupedBankingAccounts";
import type { BankAccountListItem } from "Infrastructure/Api/Api";
import type { ReactNode } from "react";

type Props = {
  groups: Array<ContextGroup>;
  renderAccount: (account: BankAccountListItem) => ReactNode;
};

export const RoleContextGroups = ({ groups, renderAccount }: Props) => (
  <Stack gap={3}>
    {groups.map(({ key, label, accounts }) => (
      <Stack key={key}>
        <Typography variant="subtitle2" color="text.secondary" mb={1}>
          {label}
        </Typography>
        {accounts.map(renderAccount)}
      </Stack>
    ))}
  </Stack>
);
